import { Box, Text } from '@chakra-ui/layout';
import { useSelector } from 'react-redux';
import { Link } from '@chakra-ui/react'

export default function ScheduleSlot({ subject, className, categoryId,colorName,time,libraryTitle ,contentUrl}) {
  const categoriesData = useSelector(
    (state) => state.categoriesState.categoriesData
  );

  const getCategoryName = () =>
    categoriesData.find((category) => category.id.toString() === categoryId)
      .name;

  return (
    <Box
       borderLeft='1px solid rgba(0, 0, 0, 0.1)'
      flex='1'
      height={subject ? '100%' : '160px'}
      display='flex'
      flexDir='column'
      justifyContent='center'
      alignItems='center'
      color='#999999'
      style={{ fontFamily: 'Mulish, sans-serif'  }}
    >
    {subject ?
     <Box w='95%' bg={subject==='Computer Science' ? '#e5f7ff' : subject==='Physics' ? '#f0e9ff' :subject==='Data Science' ? '#deefe7':subject==='Chemistry' ? '#ffebe9' : '#f8f3d6'}  p={4} color={subject==='Computer Science' ? '#4682af' : subject==='Physics' ? '#7958c9' :subject==='Data Science' ? '#26ce83':subject==='Chemistry' ? '#fa5b59' : '#967132'} borderRadius='10px'>
       {categoryId && categoriesData.length > 0 && (
        <Link href={contentUrl} isExternal><Text fontWeight='800' style={{marginTop: '12px',fontSize: '15px'}}>{getCategoryName()}</Text></Link>
      )}
       
     <Text style={{fontSize: '12px',float:'right'}}  d='flex' flex='1' flexDir='row'>{`${subject.substring(0, 20)}...`}  </Text>
    </Box>:
    <Box></Box>
}


    </Box>
  );
}
